export const programProgressData: Record<
  string,
  {
    province: string;
    percentage: number;
  }[]
> = {
  kemiskinan: [
    { province: "Papua", percentage: 26 },
    { province: "Papua Barat", percentage: 21 },
    { province: "Nusa Tenggara Timur", percentage: 20 },
    { province: "Maluku", percentage: 17 },
    { province: "Gorontalo", percentage: 15 },
  ],

  "yatim-dhuafa": [
    { province: "Jawa Barat", percentage: 32 },
    { province: "Jawa Timur", percentage: 29 },
    { province: "Jawa Tengah", percentage: 25 },
    { province: "Banten", percentage: 18 },
    { province: "Sumatera Utara", percentage: 15 },
  ],

  janda: [
    { province: "Jawa Timur", percentage: 30 },
    { province: "Jawa Tengah", percentage: 27 },
    { province: "Jawa Barat", percentage: 24 },
    { province: "Lampung", percentage: 16 },
    { province: "NTB", percentage: 14 },
  ],

  "bencana-alam": [
    { province: "Jawa Barat", percentage: 35 },
    { province: "Sulawesi Tengah", percentage: 28 },
    { province: "NTT", percentage: 22 },
    { province: "Sumatera Barat", percentage: 18 },
    { province: "Maluku", percentage: 15 },
  ],
};
